const apiUrl = process.env.NEXT_PUBLIC_API_URL;
const baseApiUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
const environment = process.env.NEXT_PUBLIC_ENVIRONMENT as string;
const auth0M2MAccessToken = process.env.AUTH0_M2M_ACCESS_TOKEN;
const isIpadBaseIntake = process.env.IS_IPAD_BASE_INTAKE as string;
const defaultIpadBaseIntakeUrl = process.env.IPAD_BASE_INTAKE_URL as string;
const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;
const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN as string;
const appVersion = process.env.NEXT_PUBLIC_APP_VERSION as string;
const isDatadogEnabled = (process.env.NEXT_PUBLIC_DD_ENABLED as string) === 'true';
const isTabletBaseIntake = (/true/i.test(isIpadBaseIntake));
const patientPortalLoginUrl = process.env.NEXT_PUBLIC_PATIENT_PORTAL_LOGIN_URL as string || 'https://care-qa.populateemr.com';

export {
  baseApiUrl,
  apiUrl,
  environment,
  auth0M2MAccessToken,
  isIpadBaseIntake,
  defaultIpadBaseIntakeUrl,
  googleMapsApiKey,
  datadogClientToken,
  appVersion,
  isDatadogEnabled,
  isTabletBaseIntake,
  patientPortalLoginUrl,
};
